import {
  GoabBlock,
  GoabDetails,
  GoabFormItem,
  GoabRadioGroup,
  GoabRadioItem,
} from "@abgov/react-components";

import { bankAccountFields } from "../../../../constants";
import {
  useGenerationForm,
  useSessionManagement,
} from "../../../../../GenerationForm/hooks";

import BankDetails from "../../../../../../../MPP-Common-SPA/Widgets/BankDetails/BankDetails";

export const BankAccountDetailsETransfer = () => {
  const { form, handleBankAccountDetailsToggle, isReady } =
    useGenerationForm("PaymentInformation");

  const { getResourceValue } = useSessionManagement();

  // Early return if form not ready.
  if (!isReady) return null;

  // Bank details custom form
  const bankForm = {
    values: {
      institutionNumber:
        form.values.PaymentInformation?.institutionNumber || "",
      transitNumber: form.values.PaymentInformation?.transitNumber || "",
      bankAccount: form.values.PaymentInformation?.bankAccount || "",
      confirmBankAccount:
        form.values.PaymentInformation?.confirmBankAccount || "",
      bankName: form.values.PaymentInformation?.bankName || "",
    },
    errors: {
      institutionNumber: (form.errors.PaymentInformation as any)
        ?.institutionNumber,
      transitNumber: (form.errors.PaymentInformation as any)?.transitNumber,
      bankAccount: (form.errors.PaymentInformation as any)?.bankAccount,
      confirmBankAccount: (form.errors.PaymentInformation as any)
        ?.confirmBankAccount,
    },
    touched: {
      institutionNumber: (form.touched?.PaymentInformation as any)
        ?.institutionNumber,
      transitNumber: (form.touched?.PaymentInformation as any)?.transitNumber,
      bankAccount: (form.touched?.PaymentInformation as any)?.bankAccount,
      confirmBankAccount: (form.touched?.PaymentInformation as any)
        ?.confirmBankAccount,
    },
    setFieldValue: (name: string, value: any) => {
      form.setFieldValue(`PaymentInformation.${name}`, value);
    },
    setFieldTouched: (name: string, touched: boolean = true) => {
      form.setFieldTouched(`PaymentInformation.${name}`, touched);
    },
    setValues: (values: any) => {
      bankAccountFields.forEach((field) => {
        if (values[field] !== undefined) {
          form.setFieldValue(`PaymentInformation.${field}`, values[field]);
        }
      });
    },
  };

  const setFormData = (formValue: any) => {
    if (formValue.institutionNumber) {
      form.setFieldValue(
        "PaymentInformation.institutionNumber",
        formValue.institutionNumber
      );
    }
    if (formValue.transitNumber) {
      form.setFieldValue(
        "PaymentInformation.transitNumber",
        formValue.transitNumber
      );
    }
    if (formValue.bankAccount) {
      form.setFieldValue(
        "PaymentInformation.bankAccount",
        formValue.bankAccount
      );
    }
    if (formValue.confirmBankAccount) {
      form.setFieldValue(
        "PaymentInformation.confirmBankAccount",
        formValue.confirmBankAccount
      );
    }
    if (formValue.bankName) {
      form.setFieldValue("PaymentInformation.bankName", formValue.bankName);
    }
  };

  return (
    <>
      <GoabDetails heading="Where can I find this information?" open={true}>
        <p>
          Your banking information is usually found in the line of numbers
          printed across the bottom of your cheques. It can also be found on the
          bottom of a void cheque or a direct deposit form provided by your
          financial institution.
        </p>
        <p>
          If you need additional help, please contact your financial
          institution.
        </p>
        <img
          src="http://localhost:5106/Images/bankCheque.png"
          alt="Bank cheque"
          width={"100%"}
        />
      </GoabDetails>
      <GoabBlock direction="column" gap="m">
        <GoabFormItem label="Choose the bank account you would like to use.">
          <GoabRadioGroup
            name="bankAccountDetailsToggle"
            onChange={({name, value}) =>
              handleBankAccountDetailsToggle(name, value)
            }
            value={"Auto Deposit"}
          >
            <GoabRadioItem value="Auto Deposit" label="Auto Deposit Account" />
            <GoabRadioItem
              value="Non-Auto Deposit"
              label="Non-Auto Deposit Account"
            />
          </GoabRadioGroup>
        </GoabFormItem>

        <BankDetails
          getResourceValue={getResourceValue}
          form={bankForm}
          context={null}
          setFormData={setFormData}
          institutionNumber={form.values.PaymentInformation.institutionNumber}
          transitNumber={form.values.PaymentInformation.transitNumber}
          bankAccount={form.values.PaymentInformation.bankAccount}
          confirmBankAccount={form.values.PaymentInformation.confirmBankAccount}
          bankName={form.values.PaymentInformation.bankName}
          isGenerator={true}
        />
      </GoabBlock>
    </>
  );
};
